export const consultationConditionShow: any = {
  pageTitle: "たびチャットご提案内容",
};
